import { IconArrowBackUp } from '@tabler/icons-react';
import type React from 'react';
import { useCallback } from 'react';
import { type FileFormatApiRow, restoreFileFormat } from '@/api/file-formats';
import { FileFormatConfirmDialog } from './file-format-confirm-dialog';

interface RestoreFileFormatDialogProps {
  open: boolean;
  row: FileFormatApiRow | null;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export const RestoreFileFormatDialog: React.FC<RestoreFileFormatDialogProps> = (props) => {
  const handleConfirm = useCallback((row: FileFormatApiRow) => restoreFileFormat(row.id), []);

  return (
    <FileFormatConfirmDialog
      {...props}
      onConfirm={handleConfirm}
      icon={<IconArrowBackUp className="h-5 w-5 text-primary" />}
      title="Restore file format?"
      description={(code, scopeLabel) => (
        <>
          <p>
            This will restore <strong>{code}</strong> ({scopeLabel}).
          </p>
          <p>The format will become active again and appear in the default list.</p>
        </>
      )}
      confirmLabel="Restore"
      loadingLabel="Restoring..."
    />
  );
};
